import "./UserBadges.css";

const roleLabels = {
  POWER_ADMIN: "Admin",
  POWER_INTERNAL_COACH: "Interne coach",
  POWER_EXTERNAL_COACH: "Externe coach",
};

const statusLabels = {
  INVITED: "Uitgenodigd",
  ACTIVE: "Actief",
  BLOCKED: "Geblokkeerd",
  DISABLED: "Uitgeschakeld",
};

export function UserRoleBadge({ role }) {
  return (
    <span className={`user-badge user-badge--role-${role || "unknown"}`}>
      {roleLabels[role] || role || "Onbekend"}
    </span>
  );
}

export function UserStatusBadge({ status }) {
  return (
    <span className={`user-badge user-badge--status-${status || "unknown"}`}>
      {statusLabels[status] || status || "Onbekend"}
    </span>
  );
}
